import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import logoADUTEM from "../../assets/img/logoadutem.png";

const ReservasSocios = () => {
  const navigate = useNavigate();

  const [espacios, setEspacios] = useState([]);
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [espacioSeleccionado, setEspacioSeleccionado] = useState(null);
  const [showReservaModal, setShowReservaModal] = useState(false); // ← nuevo
  const [fecha, setFecha] = useState("");
  const [horaInicio, setHoraInicio] = useState("");
  const [horaFin, setHoraFin] = useState("");
  const [tipoPiscina, setTipoPiscina] = useState("PERSONAL");
  const [observacion, setObservacion] = useState("");

  const [horariosOcupados, setHorariosOcupados] = useState([]);
  const [cargandoHorarios, setCargandoHorarios] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [reservaData, setReservaData] = useState(null);

  const horasBase = Array.from({ length: 17 }, (_, i) => `${String(i + 6).padStart(2, "0")}:00`);

  const horasPosiblesInicio = horasBase.filter((hora) =>
    !horariosOcupados.some((ocup) => hora >= ocup.hora_inicio && hora < ocup.hora_fin)
  );

  const horasPosiblesFin = horaInicio
    ? horasBase.filter((hora) => {
        if (hora <= horaInicio) return false;
        return !horariosOcupados.some((ocup) => {
          return ocup.hora_inicio < hora && ocup.hora_fin > horaInicio;
        });
      })
    : [];

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [perfilRes, espaciosRes] = await Promise.all([
          axios.get("/perfil"),
          axios.get("/espacios-disponibles"),
        ]);
        if (perfilRes.data?.ok) {
          setUsuario(perfilRes.data.perfil || perfilRes.data.usuario || null);
        }
        setEspacios(espaciosRes.data.espacios || []);
      } catch (err) {
        const msg =
          err.response?.data?.message ||
          err.response?.data?.msg ||
          err.message ||
          "No se pudieron cargar los datos";
        setError(msg);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    if (!espacioSeleccionado?.id || !fecha) return;

    const loadOcupados = async () => {
      setCargandoHorarios(true);
      setHoraInicio("");
      setHoraFin("");
      try {
        const response = await axios.get("/ocupados", {
          params: { espacio_id: espacioSeleccionado.id, fecha },
        });
        setHorariosOcupados(response.data.horarios || []);
      } catch (err) {
        setHorariosOcupados([]);
      } finally {
        setCargandoHorarios(false);
      }
    };
    loadOcupados();
  }, [espacioSeleccionado?.id, fecha]);

  // Abrir modal de reserva al seleccionar espacio
  const handleSeleccionarEspacio = (espacio) => {
    setEspacioSeleccionado(espacio);
    setFecha("");
    setHoraInicio("");
    setHoraFin("");
    setTipoPiscina("PERSONAL");
    setObservacion("");
    setHorariosOcupados([]);
    setShowReservaModal(true); // ← abre el modal
  };

  const cerrarReservaModal = () => {
    setShowReservaModal(false);
    setEspacioSeleccionado(null);
  };

  const reservar = async () => {
    if (!observacion.trim()) {
  setModalMessage("La observación es obligatoria.");
  setShowErrorModal(true);
  return;
}
    if (!horaInicio || !horaFin) {
      setModalMessage("Selecciona hora de inicio y fin");
      setShowErrorModal(true);
      return;
    }
    if (horaInicio >= horaFin) {
      setModalMessage("La hora de fin debe ser posterior a la hora de inicio");
      setShowErrorModal(true);
      return;
    }
    try {
      const payload = {
        espacio_id: espacioSeleccionado.id,
        fecha,
        hora_inicio: horaInicio,
        hora_fin: horaFin,
        tipo_piscina: espacioSeleccionado.permite_evento ? tipoPiscina : "PERSONAL",
        observacion: observacion.trim(),
      };

      await axios.post("/reservas", payload);

      setReservaData({
        nombre: espacioSeleccionado.nombre,
        fecha,
        horaInicio,
        horaFin,
        tipo: tipoPiscina === "EVENTO" ? "Evento" : "Personal",
        observacion: observacion.trim() || "Ninguna",
      });

      setShowReservaModal(false); // cierra modal de reserva
      setShowSuccessModal(true);

      setFecha("");
      setHoraInicio("");
      setHoraFin("");
      setTipoPiscina("PERSONAL");
      setObservacion("");
      setHorariosOcupados([]);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.msg ||
        err.message ||
        "Error al procesar la reserva";
      setModalMessage(msg);
      setShowErrorModal(true);
    }
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;

  const socioNombre = usuario?.nombres || "Socio";
  const socioApellido = usuario?.apellidos || "";
  const nombreCompleto = `${socioNombre} ${socioApellido}`.trim();
  const primeraLetra = socioNombre.charAt(0).toUpperCase() || "S";

  return (
    <>
      <Navbar socioNombre={nombreCompleto} primeraLetra={primeraLetra} />

      <main className="container py-5">
        <h1 className="fw-bold mb-5" style={{ color: "#2c3e50" }}>
          <i className="bi bi-calendar-event me-3 text-success"></i>
          Reservar Espacio
        </h1>

        <div className="row g-4">
          {espacios.map((espacio) => (
            <div className="col-md-4 col-lg-3" key={espacio.id}>
              <div
                className="card h-100 shadow-sm border-0 overflow-hidden"
                onClick={() => handleSeleccionarEspacio(espacio)}
                role="button"
                tabIndex={0}
                style={{ cursor: "pointer", transition: "transform 0.15s" }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-4px)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
              >
                {espacio.imagen && (
                  <img
                    src={espacio.imagen}
                    className="card-img-top"
                    alt={espacio.nombre}
                    style={{ height: "160px", objectFit: "cover" }}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{espacio.nombre}</h5>
                  <p className="card-text text-muted small flex-grow-1">{espacio.descripcion}</p>
                  <span
                    className={`badge align-self-start mt-2 ${
                      espacio.permite_evento ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {espacio.permite_evento ? "Permite eventos" : "Uso personal"}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ===== MODAL DE RESERVA ===== */}
      {showReservaModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            onClick={(e) => { if (e.target === e.currentTarget) cerrarReservaModal(); }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content border-0 shadow rounded-4">

                {/* Header */}
                <div className="modal-header border-0 pb-0 px-4 pt-4">
                  <div>
                    <h4 className="fw-bold mb-0">{espacioSeleccionado.nombre}</h4>
                    <p className="text-muted small mt-1 mb-0">
                      Completa los datos para confirmar tu reserva
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={cerrarReservaModal}
                    aria-label="Cerrar"
                  />
                </div>

                {/* Body */}
                <div className="modal-body px-4 py-3">

                  {/* Imagen del espacio si existe */}
                  {espacioSeleccionado.imagen && (
                    <img
                      src={espacioSeleccionado.imagen}
                      alt={espacioSeleccionado.nombre}
                      className="w-100 rounded-3 mb-4"
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                  )}

                  <div className="row g-3">
                    {/* Fecha */}
                    <div className="col-md-4">
                      <label className="form-label fw-medium">Fecha</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fecha}
                        onChange={(e) => setFecha(e.target.value)}
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>

                    {/* Hora inicio */}
                    <div className="col-md-4">
                      <label className="form-label fw-medium">Hora inicio</label>
                      {cargandoHorarios ? (
                        <div className="form-control text-center text-muted">
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Cargando…
                        </div>
                      ) : horasPosiblesInicio.length === 0 && fecha ? (
                        <div className="alert alert-warning py-2 mb-0 d-flex align-items-center gap-2">
                          <i className="bi bi-clock-history fs-5"></i>
                          <span className="small fw-semibold">Sin horarios disponibles</span>
                        </div>
                      ) : (
                        <select
                          className="form-select"
                          value={horaInicio}
                          onChange={(e) => { setHoraInicio(e.target.value); setHoraFin(""); }}
                        >
                          <option value="">Seleccione</option>
                          {horasBase.map((h) => {
                            const ocupado = horariosOcupados.some(
                              (ocup) => h >= ocup.hora_inicio && h < ocup.hora_fin
                            );
                            return (
                              <option key={h} value={h} disabled={ocupado}>
                                {h}{ocupado ? " — No disponible" : ""}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>

                    {/* Hora fin */}
                    <div className="col-md-4">
                      <label className="form-label fw-medium">Hora fin</label>
                      {cargandoHorarios ? (
                        <div className="form-control text-center text-muted">
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Cargando…
                        </div>
                      ) : (
                        <select
                          className="form-select"
                          value={horaFin}
                          onChange={(e) => setHoraFin(e.target.value)}
                          disabled={!horaInicio || horasPosiblesFin.length === 0}
                        >
                          <option value="">Seleccione</option>
                          {horasBase
                            .filter((h) => h > horaInicio)
                            .map((h) => {
                              const ocupado = horariosOcupados.some(
                                (ocup) => ocup.hora_inicio < h && ocup.hora_fin > horaInicio
                              );
                              return (
                                <option key={h} value={h} disabled={ocupado}>
                                  {h}{ocupado ? " — No disponible" : ""}
                                </option>
                              );
                            })}
                        </select>
                      )}
                    </div>
                  </div>

                  {/* Horarios ocupados */}
                  {horariosOcupados.length > 0 && fecha && (
                    <div className="mt-3 p-3 rounded-3 border"
                      style={{ background: "#fff5f5", borderColor: "#f5c6cb" }}>
                      <p className="small fw-bold text-danger mb-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        Horarios ya reservados para este día:
                      </p>
                      <div className="d-flex flex-wrap gap-2">
                        {horariosOcupados.map((ocup, i) => (
                          <span key={i} className="badge px-3 py-2"
                            style={{ background: "#ffe0e0", color: "#c0392b",
                              border: "1px solid #f5b7b1", fontSize: "0.85rem" }}>
                            <i className="bi bi-x-circle-fill me-1"></i>
                            {ocup.hora_inicio} – {ocup.hora_fin}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Sin disponibilidad total */}
                  {horasPosiblesInicio.length === 0 && fecha && !cargandoHorarios && (
                    <div className="alert alert-danger mt-3 d-flex align-items-center gap-2">
                      <i className="bi bi-calendar-x fs-4"></i>
                      <div>
                        <strong>Espacio no disponible</strong>
                        <p className="mb-0 small">
                          Todos los horarios del <strong>{fecha}</strong> están ocupados.
                          Por favor selecciona otra fecha.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Tipo de uso */}
                  {espacioSeleccionado.permite_evento && (
                    <div className="mt-4">
                      <label className="form-label fw-medium">Tipo de uso</label>
                      <select
                        className="form-select"
                        value={tipoPiscina}
                        onChange={(e) => setTipoPiscina(e.target.value)}
                      >
                        <option value="PERSONAL">Uso personal</option>
                        <option value="EVENTO">Evento / celebración</option>
                      </select>
                    </div>
                  )}

                  {/* Observación */}
                  <div className="mt-4">
                    <label className="form-label fw-medium">
  Observación <span className="text-danger">*</span>
</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={observacion}
                      onChange={(e) => setObservacion(e.target.value)}
                      placeholder="Ejemplo: cumpleaños de mi hijo, reunión familiar…"
                    />
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 px-4 pb-4 gap-2">
                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={cerrarReservaModal}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success px-5"
                    onClick={reservar}
                    disabled={
                      cargandoHorarios ||
                      !fecha ||
                      !horaInicio ||
                      !horaFin ||
                      horasPosiblesInicio.length === 0
                    }
                  >
                    <i className="bi bi-check2-circle me-2"></i>
                    Confirmar Reserva
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}

      {/* Modal Éxito */}
      <div
        className={`modal fade ${showSuccessModal ? "show" : ""}`}
        style={{ display: showSuccessModal ? "block" : "none" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow rounded-4">
            <div className="modal-header bg-success text-white border-0">
              <h5 className="modal-title">¡Reserva Confirmada!</h5>
              <button type="button" className="btn-close btn-close-white"
                onClick={() => setShowSuccessModal(false)} />
            </div>
            <div className="modal-body text-center py-5">
              <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "5rem" }} />
              <h4 className="mt-4">Todo listo</h4>
              {reservaData && (
                <div className="mt-4 text-start px-4">
                  <p><strong>Espacio:</strong> {reservaData.nombre}</p>
                  <p><strong>Fecha:</strong> {reservaData.fecha}</p>
                  <p><strong>Horario:</strong> {reservaData.horaInicio} – {reservaData.horaFin}</p>
                  <p><strong>Tipo:</strong> {reservaData.tipo}</p>
                  {reservaData.observacion !== "Ninguna" && (
                    <p><strong>Observación:</strong> {reservaData.observacion}</p>
                  )}
                </div>
              )}
            </div>
            <div className="modal-footer border-0 justify-content-center">
              <button className="btn btn-success px-5" onClick={() => setShowSuccessModal(false)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Error */}
      <div
        className={`modal fade ${showErrorModal ? "show" : ""}`}
        style={{ display: showErrorModal ? "block" : "none" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow rounded-4">
            <div className="modal-header bg-danger text-white border-0">
              <h5 className="modal-title">No se pudo reservar</h5>
              <button type="button" className="btn-close btn-close-white"
                onClick={() => setShowErrorModal(false)} />
            </div>
            <div className="modal-body text-center py-5">
              <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: "5rem" }} />
              <h4 className="mt-4">Atención</h4>
              <p className="text-muted px-4">{modalMessage}</p>
            </div>
            <div className="modal-footer border-0 justify-content-center">
              <button className="btn btn-danger px-5" onClick={() => setShowErrorModal(false)}>
                Entendido
              </button>
            </div>
          </div>
        </div>
      </div>

      {(showSuccessModal || showErrorModal) && <div className="modal-backdrop fade show" />}
    </>
  );
};

// ───────────────────────────────────────────────
// NAVBAR
// ───────────────────────────────────────────────
const Navbar = ({ socioNombre, primeraLetra }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark shadow-sm"
      style={{
        background: "#FFD123",
        padding: "18px 0",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <div className="container-fluid px-4">
        <Link className="navbar-brand d-flex align-items-center" to="/DashboardSocio">
          <img src={logoADUTEM} alt="ADUTEM" style={{ height: "68px" }} />
        </Link>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto gap-1">
            {[
              { to: "/DashboardSocio", label: "Inicio", end: true },
              { to: "/vercuotas", label: "Mis Cuotas" },
              { to: "/reservasSocios", label: "Reservas" },
              { to: "/MisReservas", label: "Mis Reservas" },
            ].map(({ to, label, end = false }) => (
              <li className="nav-item" key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    `nav-link px-4 py-2 rounded-pill fw-medium transition-all ${
                      isActive
                        ? "active bg-white text-dark shadow-sm"
                        : "text-white hover-bg-white hover-text-dark"
                    }`
                  }
                  style={{ fontSize: "1.02rem" }}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="dropdown">
            <button
              className="btn btn-link text-decoration-none p-0 border-0 d-flex align-items-center gap-2"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center shadow"
                style={{
                  width: "42px", height: "42px",
                  backgroundColor: "#f1c40f", color: "#2c3e50",
                  fontWeight: "700", fontSize: "1.25rem",
                  border: "2px solid rgba(255,255,255,0.6)",
                }}
              >
                {primeraLetra}
              </div>
              <div className="text-white text-start d-none d-md-block">
                <div className="fw-medium" style={{ fontSize: "1.02rem" }}>{socioNombre}</div>
                <small className="opacity-75" style={{ fontSize: "0.82rem" }}>Socio</small>
              </div>
              <i className="bi bi-chevron-down text-white ms-1" style={{ fontSize: "1rem" }}></i>
            </button>

            <ul className="dropdown-menu dropdown-menu-start shadow-lg border-0 py-2">
              <li>
                <Link className="dropdown-item d-flex align-items-center py-2" to="/perfil">
                  <i className="bi bi-person-circle me-3 fs-5"></i>
                  Mi Perfil
                </Link>
              </li>
              <li><hr className="dropdown-divider my-1" /></li>
              <li>
                <button
                  className="dropdown-item d-flex align-items-center py-2 text-danger"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right me-3 fs-5"></i>
                  Cerrar sesión
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

// ───────────────────────────────────────────────
// Loading y Error States
// ───────────────────────────────────────────────
const LoadingState = () => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center">
    <div className="text-center">
      <div className="spinner-border text-success"
        style={{ width: "3.5rem", height: "3.5rem" }} role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
      <p className="mt-4 fs-5 text-muted">Cargando espacios disponibles...</p>
    </div>
  </div>
);

const ErrorState = ({ message }) => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center p-4">
    <div className="alert alert-danger text-center shadow p-5" style={{ maxWidth: "500px" }}>
      <i className="bi bi-exclamation-triangle-fill me-3 fs-3"></i>
      <h4 className="mb-3">Error</h4>
      <p>{message || "No pudimos cargar los espacios"}</p>
      <button className="btn btn-outline-danger mt-3" onClick={() => window.location.reload()}>
        Reintentar
      </button>
    </div>
  </div>
);

export default ReservasSocios;